<script>
  import { t } from 'svelte-i18n';
  import ModalSection from './modal-section.svelte';
    import Footer from './footer.svelte';
</script>

<ModalSection first="true">
  <div slot="text">
    <h1 class="pb-0 text-uniapp-primary">Uniapp</h1>
    <h1 class="pt-0">{$t('MODAL.UNIAPP.TITLE')}</h1>
  </div>
  <p class="text-opaque-black md2:mb-9" slot="padding">
    {$t('MODAL.UNIAPP.DESCRIPTION')}
  </p>
  <img
    class="ml-5 md2:ml-0"
    slot="img"
    alt="uniapp screen on a mobile device"
    src="images/uniapp-img1.png"
  />
</ModalSection>

<ModalSection app="uniapp" bgDark="true" inverse="true">
  <div slot="text">
    <h1>{$t('MODAL.UNIAPP.TITLE2')}</h1>
    <p class="text-opaque-black">
      {@html $t('MODAL.UNIAPP.DESCRIPTION2')}
    </p>
  </div>
  <img slot="img" alt="uniapp screen on a mobile device" src="images/uniapp-img2.png" />
</ModalSection>

<ModalSection>
  <div slot="text">
    <h1>{$t('MODAL.UNIAPP.TITLE3')}</h1>
    <p class="text-opaque-black">
      {$t('MODAL.UNIAPP.DESCRIPTION3')}
    </p>
  </div>
  <img
    class="ml-5 md2:ml-0"
    slot="img"
    alt="uniapp screen on a mobile device"
    src="images/uniapp-img3.png"
  />
</ModalSection>
<Footer />

<style>
  p {
    @apply py-0;
  }
  img {
    filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.35));
  }
</style>
